import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../context';

function Home() {


    const navigate = useNavigate();

    useEffect(() => {
        navigate("/buying-currency")
    },[])
  return (
    <div>
      
    </div>
  )
}

export default Home
